<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
<!-- <a href="https://1.envato.market/vuexy_admin" target="_blank" rel="nofollow">Pixinvent</a> -->
    <footer class="the-footer flex-wrap" :class="classes">
        <img src="@/assets/images/logo/Etecno.png" width="150px">
        <span> &nbsp; Powered By Etecno, SA de C.V. &nbsp; {{ new Date().getFullYear() }}, <a href="http://administraflotilla.com/?_np=true" target="_blank" rel="nofollow" >Todos los derechos reservados</a>&nbsp;</span>
        <img src="https://image.flaticon.com/icons/svg/630/630615.svg" width="30px">
        <span class="md:flex hidden items-center">
            <!-- <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" /> -->
        </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
